// @flow
import React from 'react';
import type { Node } from 'react';

export default function App({ children }: { children: Node }) {
  return <div>{children}</div>;
}
